// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.1-beta.a6898e694',
  revision: 'a6898e694',
  branch: 'develop',
  date: 'Thu, 24 Sep 2026 20:13:03 GMT'
};